<template>
  <div class="banner">
    <p>{{ $t('settings.readOnlyAccess') }}</p>
  </div>
</template>

<script>
export default {
  name: 'banner'
};
</script>